import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { ActivatedRoute } from '@angular/router';
import { TankatableLstInformationDto } from 'sg-api';
import { DisplayMode } from 'cbc-shared-lib';

/** 単価表検索画面（検索結果）
 * @export
 * @class TankatableSearchResultComponent
 * @implements {OnInit,OnDestroy} 
 */
@Component({
    selector: 'app-sgkc021d-tanka-table-search-result',
    templateUrl: './sgkc021d-tanka-table-search-result.component.html',
    styleUrl: './sgkc021d-tanka-table-search-result.component.scss',
})
export class Sgkc021dTankaTableSearchResultComponent implements OnInit, OnDestroy {
    /** 単価表検索結果 */
    @Input() tankatable: TankatableLstInformationDto[];
    /** 画面モード */
    @Input() mode: string;
    /** 行ダブルクリック時のイベント */
    @Output() onDbClickRowEvent = new EventEmitter<TankatableLstInformationDto>();
    /** 追加ボタン押下時のイベント */
    @Output() onClickAddEvent = new EventEmitter<void>();
    /** ラジオボタン変更時のイベント */
    @Output() onSelectedEvent = new EventEmitter<TankatableLstInformationDto>();
    /** テーブルのページング機能 */
    @ViewChild('paginator', { static: true }) paginator: MatPaginator;
    /** テーブルのソート機能 */
    @ViewChild('sort', { static: true }) sort: MatSort;

    /** 追加ボタンの表示フラグ */
    isAddButtonVisible: boolean = false;
    /** 追加ボタンの活性フラグ */
    isAddButtonDisabled: boolean = true;
    /** ラジオボタンの活性フラグ */
    isRadioButtonDisabled: boolean = true;
    /** 検索結果表示リスト */
    displayedColumnsCol: string[] = [
        'select',
        'tankatableAname',
        'applyStartDate',
        'applyEndDate',
        'tankatableExplanation',
        'apprvStsAname',
    ];
    /** 検索結果格納データソース */
    dataSource = new MatTableDataSource<TankatableLstInformationDto>();

    /** 
     * コンストラクタ
    * @param {Router} router
    * @memberof Sgkc021dTankaTableSearchResultComponent
    */
    constructor(
        private route: ActivatedRoute,
    ) {
    }

    /** 初期処理
    * @memberof Sgkc021dTankaTableSearchResultComponent
    */
    ngOnInit(): void {

        // 追加ボタン、ラジオボタンの制御
        if (this.mode === DisplayMode.create) {
            this.isAddButtonVisible = true;
            this.isRadioButtonDisabled = false;
        } else {
            this.isAddButtonVisible = false;
            this.isRadioButtonDisabled = true;
        }
        this.dataSource.data = this.tankatable;
    }

    /** 初期化後の処理
     * @memberof Sgkc021dTankaTableSearchResultComponent
     */
    ngAfterViewInit() {
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    }

    /** 
     * コンポーネント破棄時の処理
     * @memberof Sgkc021dTankaTableSearchResultComponent
     */
    ngOnDestroy(): void {
    }

    /** 
     * 行ダブルクリック時の処理
     * @param {TankatableLstInformationDto} row
     * @param {*} event
     * @memberof Sgkc021dTankaTableSearchResultComponent
     */
    onDbClickRow(row: TankatableLstInformationDto, event: any): void {
        const target = event.target as HTMLElement;
        if (target.closest('mat-radio-button')) {
            return;
        }
        this.onDbClickRowEvent.emit(row);
    }

    /** 
     * ラジオボタン変更時の処理
     * @param {*} event
     * @param {TankatableLstInformationDto} row
     * @memberof Sgkc021dTankaTableSearchResultComponent
     */
    onChangeRadio(event: any, row: TankatableLstInformationDto): void {
        if (event) {
            this.isAddButtonDisabled = false;
            this.onSelectedEvent.emit(row);
        }
    }

    /** 
     * 追加ボタン押下時の処理
     * @memberof Sgkc021dTankaTableSearchResultComponent
     */
    onClickAdd(): void {
        this.onClickAddEvent.emit();
    }
}